export default {
    cn: {
        symbolProfit: {
            excelName: '产品盈亏报表',
            endOfDayDownload: '下载日结Excel',
            nowDownload: '下载实时Excel',
            placeholder: '日结产品盈亏日期',
            warning: '请先选择一个日结产品盈亏日期',
            tableHead: [
                { key: 'SYMBOL', value: '产品' },
                { key: 'PREVIOUS_OPEN_VOLUME', value: '上日未平仓手数' },
                { key: 'PREVIOUS_FLOATING_PL', value: '上日浮动盈亏' },
                { key: 'PRESENT_FLOATING_PL', value: '今日浮动盈亏' },
                { key: 'PRESENT_CLOSED_PL', value: '今日平仓盈亏' },
                { key: 'PRESENT_CLOSED_SWAP', value: '今日平仓利息' },
                { key: 'PRESENT_CLOSED_VOLUME', value: '今日平仓手数' },
                { key: 'PRESENT_NO_COMMISSION_PL', value: '今日盈亏(未扣代理返佣)' },
                { key: 'PRESENT_CLOSED_COMMISSION', value: '今日平仓佣金' },
                { key: 'PRESENT_IB_COMMISSION', value: '今日代理返佣' },
                { key: 'PRESENT_PL', value: '今日盈亏(客户角度)' },
            ]
        }
    },
    hk: {
        symbolProfit: {
            excelName: '產品盈虧報表',
            endOfDayDownload: '下載日結Excel',
            nowDownload: '下載實時Excel',
            placeholder: '日結產品盈虧日期',
            warning: '請先選擇一個日結產品盈虧日期',
            tableHead: [
                { key: 'SYMBOL', value: '產品' },
                { key: 'PREVIOUS_OPEN_VOLUME', value: '上日未平倉手數' },
                { key: 'PREVIOUS_FLOATING_PL', value: '上日浮動盈虧' },
                { key: 'PRESENT_FLOATING_PL', value: '今日浮動盈虧' },
                { key: 'PRESENT_CLOSED_PL', value: '今日平倉盈虧' },
                { key: 'PRESENT_CLOSED_SWAP', value: '今日平倉利息' },
                { key: 'PRESENT_CLOSED_VOLUME', value: '今日平倉手數' },
                { key: 'PRESENT_NO_COMMISSION_PL', value: '今日盈虧(未扣代理返佣)' },
                { key: 'PRESENT_CLOSED_COMMISSION', value: '今日平倉佣金' },
                { key: 'PRESENT_IB_COMMISSION', value: '今日代理返佣' },
                { key: 'PRESENT_PL', value: '今日盈虧(客戶角度)' },
            ],
        }
    },
    en: {
        symbolProfit: {
            excelName: 'Symbol Profit Report',
            endOfDayDownload: 'Download Daily Excel',
            nowDownload: 'Download Realtime Excel',
            placeholder: 'Daily symbol profit date',
            warning: 'Please select a daily symbol profit date',
            tableHead: [
                { key: 'SYMBOL', value: 'Symbol' },
                { key: 'PREVIOUS_OPEN_VOLUME', value: 'Previous Open Volume' },
                { key: 'PREVIOUS_FLOATING_PL', value: 'Previous Floating PL' },
                { key: 'PRESENT_FLOATING_PL', value: 'Present Floating PL' },
                { key: 'PRESENT_CLOSED_PL', value: 'Present Closed PL' },
                { key: 'PRESENT_CLOSED_SWAP', value: 'Present Closed Swaps' },
                { key: 'PRESENT_CLOSED_VOLUME', value: 'Present Closed Volume' },
                { key: 'PRESENT_NO_COMMISSION_PL', value: 'Present PL(Without IB Commission)' },
                { key: 'PRESENT_CLOSED_COMMISSION', value: 'Present Closed Commission' },
                { key: 'PRESENT_IB_COMMISSION', value: 'Present IB Commission' },
                { key: 'PRESENT_PL', value: 'Present PL(The customer perspective)' },
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/manager-report/symbolProfit.js